import React from 'react'
import '../AdminCommonCom/Header.css'

const StudentFooter = () => {
  return (
    <div className="row p-0 py-2 text-center m-0 text-white fixed-bottom" style={{backgroundColor:"#235784"}}>
        <span className='footer-text'>© 2025 MANIKBAG DIGAMBAR JAIN BOARDING | Managed By : TechnoAarv Solution</span>
      </div>
  )
}

export default StudentFooter